import 'core-js/stable';
import Vue from 'vue';
import Menu from './components/Menu.vue';

(function (global) {
  initializeApp();

  function initializeApp() {
    const bus = initializeBus();
    setBusAndCart(bus);
    const permissions = fetchTenantPermissions(bus);
    const iframe = checkIframe();
    initializeMenu(permissions, iframe);
    initializeFooter(global.dbpvnext.modules.skin.tenant);
  }

  function initializeBus() {
    if (!Vue.prototype.$bus) {
      Vue.prototype.$bus = new Vue({
        data: {
          tenantFetching: false,
          shoppingCart: {
            enabled: false,
            count: 0,
            orderGuid: null,
            workflowId: null,
          },
          messagingCenter: {
            enabled: false,
            loading: false,
            total: 0,
            unread: 0,
            notifications: []
          },
          currencySelector: null,
          tenant: {
            metadata: {
              menu: null,
            },
            permissions: {},
            configuration: null,
            success: null            
          },
        },
      });
    }
    return Vue.prototype.$bus;
  }

  function setBusAndCart(bus) {
    const tenant = global.dbpvnext.modules.skin?.tenant ?? null;
    bus.tenant = tenant;
    const configuration = tenant.configuration;
    bus.shoppingCart.enabled = tenant.metadata[configuration]?.shoppingCart ?? false;
    bus.messagingCenter.enabled = tenant.metadata[configuration]?.messagingCenter?.enabled ?? false;
  }

  function fetchTenantPermissions(bus) {
    try {

      const perms = [];
      Object.keys(bus.tenant?.permissions ?? {}).forEach((prop) => {
        Object.keys(bus.tenant.permissions[prop] ?? {}).forEach((perm) => {
          if (bus.tenant.permissions[prop][perm].includes('read') && !perms.includes(perm)) {
            perms.push(perm);
          }
        });
      });
      return perms;

    } catch (e) {
      console.error('Error fetching tenant permissions:', e);
      return [];
    }
  }

  function isDesigner() {
    try {
      return window.top.dbpvnext?.modules?.ufdesigner !== undefined;
    } catch (e) {
      console.warn('Error determining if designer:', e);
      return false;
    }
  }

  function checkIframe() {
    try {
      if (window.self !== window.top && !isDesigner()) {
        applyIframeStyles();
        return true;
      }
    } catch (e) {
      console.warn('Failed to access window object to determine iframe:', e);
    }
    return false;
  }

  function applyIframeStyles() {
    const css = 'header, footer, #dnn_FooterPaneContained { display: none; } .dbp.iframe-mt-0 { margin-top: 0 !important; }';
    const style = document.createElement('style');
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function initializeMenu(permissions, iframe) {
    const { authenticated, isVerified, loginUrl, logoffUrl, logoSnippet, profileUrl, tenant } = global.dbpvnext.modules.skin;
    new Vue({
      el: '#navigation',
      render: (h) =>
        h(Menu, {
          props: {
            authenticated,
            isVerified,
            loginUrl,
            logoffUrl,
            logoSnippet,
            profileUrl,
            tenant,
            iframe,
            skinPermissions: permissions,
          },
        }),
      mounted() {
        try {
          Vue.prototype.$nav = this.$children[0];
        } catch (e) {
          console.error('Error initializing menu:', e);
        }
      },
    });

  }

  function initializeFooter(tenant) {

    const footer = tenant.metadata?.pageFooter;
    if (footer && Array.isArray(footer.links)) {

      let footerLinks = document.getElementById("footer-links");
      document.querySelectorAll("#footer-links .footer-link").forEach(function (l) {
        l.parentNode.removeChild(l);
      });

      footer.links.forEach(function (l) {
        let li = document.createElement("li");
        let a = document.createElement("a");
        let text = document.createTextNode(l.text);
        a.appendChild(text);
        a.href = l.href;
        a.target = l.target;
        li.appendChild(a);
        footerLinks.appendChild(li);
      });
    }

    document.querySelector("footer .disclaimer").classList.add("in", "show");
  }

})(window);
